import { useRouter } from '@application/utils';
import { CountryCode } from '@gql/graphql';
import { LocaleSwitcher } from '@presentation/components';
import { useCookiePreferencesModal } from '../../CookiePreferencesModalController';

export const useFormatFooter = (localeSwitcher: any) => {
  const { translate, routeLocationDescriptor, countryCode } = useRouter();
  const { show } = useCookiePreferencesModal();

  const showImpressum = countryCode === CountryCode.DE;

  const showAnimalWellbeing = ![CountryCode.CH, CountryCode.DE].includes(countryCode);

  const categories = [
    {
      title: translate('footer.adoption.title'),
      links: [
        {
          label: translate('footer.adoption.links.puppies'),
          link: routeLocationDescriptor('litterList'),
        },
        {
          label: translate('footer.adoption.links.breeders'),
          link: routeLocationDescriptor('breederList'),
        },
        {
          label: translate('footer.adoption.links.breeds'),
          link: routeLocationDescriptor('breedList'),
        },
        {
          label: translate('footer.adoption.links.breedComparator'),
          link: routeLocationDescriptor('breedComparator'),
        },
        {
          label: translate('footer.adoption.links.puppiesPerBreed'),
          link: routeLocationDescriptor('litterLinks'),
        },
        {
          label: translate('footer.adoption.links.breedersPerBreed'),
          link: routeLocationDescriptor('breederLinks'),
        },
        {
          label: translate('footer.adoption.links.register'),
          link: routeLocationDescriptor('breederLanding'),
        },
      ],
    },
    {
      title: translate('footer.pros.title'),
      links: [
        {
          label: translate('footer.pros.links.home'),
          link: routeLocationDescriptor('proLanding'),
        },
        {
          label: translate('footer.pros.links.vets'),
          link: routeLocationDescriptor('vetList'),
        },
        {
          label: translate('footer.pros.links.groomers'),
          link: routeLocationDescriptor('groomerList'),
        },
        {
          label: translate('footer.pros.links.educators'),
          link: routeLocationDescriptor('educatorList'),
        },
        {
          label: translate('footer.pros.links.vetsRegister'),
          link: routeLocationDescriptor('joinVet'),
        },
        {
          label: translate('footer.pros.links.groomersRegister'),
          link: routeLocationDescriptor('joinGroomer'),
        },
        {
          label: translate('footer.pros.links.educatorsRegister'),
          link: routeLocationDescriptor('joinEducator'),
        },
        {
          label: translate('footer.pros.links.vetsPerCity'),
          link: routeLocationDescriptor('vetLocationLinks'),
        },
        {
          label: translate('footer.pros.links.groomersPerCity'),
          link: routeLocationDescriptor('groomerLocationLinks'),
        },
        {
          label: translate('footer.pros.links.educatorsPerCity'),
          link: routeLocationDescriptor('educatorLocationLinks'),
        },
      ],
    },
    {
      title: translate('footer.about.title'),
      links: [
        {
          label: translate('footer.about.links.articles'),
          link: routeLocationDescriptor('articleList'),
        },
        {
          label: translate('footer.about.links.team'),
          link: routeLocationDescriptor('team'),
        },
        {
          label: translate('footer.about.links.story'),
          link: routeLocationDescriptor('story'),
        },
        {
          label: translate('footer.about.links.chart'),
          link: routeLocationDescriptor('chart'),
        },
        {
          label: translate('footer.about.links.contact'),
          link: routeLocationDescriptor('contact'),
        },
        {
          label: translate('footer.about.links.faqBreeders'),
          link: routeLocationDescriptor('faqBreeder'),
        },
        {
          label: translate('footer.about.links.faqBuyers'),
          link: routeLocationDescriptor('faqBuyer'),
        },
      ],
      children: <LocaleSwitcher {...localeSwitcher.props} parentColor="light" />,
    },
  ];

  const rows = [
    {
      links: [
        {
          label: translate('footer.general.terms'),
          link: routeLocationDescriptor('terms'),
        },
        {
          label: translate('footer.general.privacyPolicy'),
          link: routeLocationDescriptor('privacy'),
        },
        {
          label: translate('footer.general.cookiePolicy'),
          link: routeLocationDescriptor('cookies'),
        },
        {
          label: translate('footer.general.cookiePreferences'),
          onClick: () => {
            show();
          },
        },
        ...(showImpressum
          ? [
              {
                label: translate('footer.general.impressum'),
                link: routeLocationDescriptor('impressum'),
              },
            ]
          : []),
      ],
    },
    {
      links: [
        ...(showAnimalWellbeing
          ? [
              {
                label: translate('footer.general.animalWellbeing.label'),
                link: '#',
                onClick: () => {
                  window.open(translate('footer.general.animalWellbeing.link'), '_blank');
                },
              },
            ]
          : []),
        {
          label: translate('footer.general.recognitionNumber.label'),
          onClick: () => {
            window.open(translate('footer.general.recognitionNumber.link'), '_blank');
          },
        },
      ],
    },
    {
      links: [
        {
          label: translate('footer.general.copyright').replace(
            '$year',
            new Date().getFullYear().toString(),
          ),
          link: '#',
        },
      ],
    },
  ];

  return { categories, rows };
};
